import React, { useEffect, useState } from "react";
import MUIMenu from "@mui/material/Menu";
import { Button, Box } from "@InnoUI";
import MenuItem from "@mui/material/MenuItem";
import SearchBar from "../../SearchBar";
import SearchIcon from "@mui/icons-material/Search";
import theme from "@theme";
import SC from "../style";
import jenny from "../../../../assets/jenny.png";
import Avatarr from "../Avatar";
import InnoIcons from "InnoUI/innoicons";
import { useSelector } from "react-redux";
import { getRoleName } from "utils/helper";
import TooltipText from "components/TooltipText";
import { Link } from "react-router-dom";

const Menu = (props) => {
  const { item, onSearch, isMobile, fontWeight, fontSize } = props;
  const [options, setOptions] = useState(item.options ? item.options : []);

  const [anchorEl, setAnchorEl] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const open = Boolean(anchorEl);
  const authData = useSelector((state) => state?.authdata?.data || []);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const accessLevel = useSelector(
    (state) => state?.authdata?.data?.userType || 0
  );

  useEffect(() => {
    setOptions(item.options ? item.options : []);
    setSearchInput("");
  }, [anchorEl]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    if (onSearch) {
      onSearch(query);
    }
  };

  const filteredOptions = (data) => {
    try {
      var newdata = data.filter(
        (item) =>
          item.menuItem &&
          item.menuItem.toLowerCase().includes(searchInput.toLowerCase())
      );
    } catch (e) {
      return [];
    }

    return newdata;
  };

  if (!item.visible) {
    return null;
  }

  return (
    <Box>
      <Button
        onClick={options.length > 0 ? handleClick : item.onClick}
        caption={item.name}
        subcaption={item.designation}
        fontWeight={fontWeight}
        fontSize={fontSize}
        leftIcon={item.leftIcon ? <item.leftIcon /> : null}
        rightIcon={item.rightIcon ? <item.rightIcon /> : null}
        isMobile={isMobile}
        sx={{
          justifyContent: "center",
          color: item.selected ? "#fff" : "inherit",
          backgroundColor: item.selected ? "red" : "inherit",
        }}
      />
      <MUIMenu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.6)",
            border: `1px solid ${theme.colors.border}`,
          },
        }}
      >
        {item.search && (
          <SearchBar
            placeholder="Search Project"
            Icon={SearchIcon}
            onChange={handleSearchChange}
            sx={{
              color: theme.colors.search,
              margin: "0px 0px 15px 15px",
              width: "100%",
              border: `2px solid ${theme.colors.border}`,
              fontSize: "15px",
              borderRadius: "5px",
            }}
            placeholderColor={theme.colors.themeColor}
          />
        )}
        <SC.BoxContainer>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              margin: "10px",
              position: "relative",
            }}
          >
            {authData?.picture ? (
              <img
                alt={"Test Logo"}
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                }}
                src={authData?.picture}
              />
            ) : (
              <Avatarr
                alt={"Test Logo"}
                sx={{ height: "35px", width: "35px" }}
                src={jenny}
              />
            )}
            <div style={{ textAlign: "center" }}>
              <p
                style={{
                  marginBlock: "0px",
                  marginTop: "7px",
                  paddingBlock: "0px",
                  fontSize: "13px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                <TooltipText title={authData.fullName} maxLength={25} />
              </p>
              <p
                style={{
                  marginBlock: "0px",
                  paddingBlock: "0px",
                  fontSize: "12px",
                }}
              >
                {getRoleName(accessLevel)}
              </p>
            </div>

            {/* Close Icon */}
            <div
              style={{
                position: "absolute",
                top: "0px",
                right: "4px",
                transform: "translate(60%, -55%)",
                cursor: "pointer",
                background: `${theme.gradient.themeGradient}`,
                borderRadius: "50%",
                padding: "10px",
                height: "40px",
                width: "40px",
                color: "white",
              }}
            >
              <InnoIcons.CloseIcon
                sx={{ fontSize: "17px", margin: "6px 0px 0px -2px" }}
                onClick={handleClose}
              />
            </div>
          </div>

          {filteredOptions(options).map((item, index) => (
            <div key={index}>
              {item.disabled ? (
                <></>
              ) : (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleClose();
                    item.onClick();
                  }}
                  style={{
                    fontSize: isMobile ? "12px" : "15px",
                    lineHeight: "15px",
                    borderBottom: "1px solid #f3f3f3",
                    backgroundColor: item.selected
                      ? theme.colors.themeColor
                      : "inherit",
                    color: item.selected ? "#fff" : "inherit",
                    padding: "10px 10px 10px 5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "0px",
                    }}
                  >
                    {item.icon && (
                      <span
                        sx={{
                          mr: 1.5,
                        }}
                      >
                        {item.icon}
                      </span>
                    )}
                    {item.url ? (
                      <Link
                        to={item.url}
                        style={{
                          fontSize: "12px",
                          textDecoration: "none",
                          color: "inherit",
                        }}
                      >
                        {item.menuItem}
                      </Link>
                    ) : (
                      <span style={{ fontSize: "12px" }}>{item.menuItem}</span>
                    )}
                    <Box>{item.email}</Box>
                  </Box>
                </MenuItem>
              )}
            </div>
          ))}
        </SC.BoxContainer>
      </MUIMenu>
    </Box>
  );
};

export default Menu;
